import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { UpsellModalEl } from "common/widgets/upsell-modal";
export function template() {
  const {
    t
  } = this.getContext("i18n");
  return /* @__PURE__ */ jsx("div", { sel: ".oda-control", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".footer" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".analyze-btn", attrs: {
    disabled: this.attr("is-waiting-for-schedule-analysis"),
    icon: this.attr("is-waiting-for-schedule-analysis") ? "spinner" : "segment",
    theme: ButtonTheme.Tertiary
  }, on: {
    click: this.attr("show-upsell") ? this.helpers.handleClickUpsell : this.helpers.handleClickAnalyze
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, this.attr("show-upsell") ? t("reports.oda.upsell-cta") : t("reports.oda.cta")), /* @__PURE__ */ jsx("div", { sel: ".analyze-description" }, this.attr("description"))), this.state.isUpsellModalOpen ? /* @__PURE__ */ jsx(UpsellModalEl, { attrs: {
    closeable: true,
    description: this.attr("upsell-description"),
    "feature-gate-type": "oda",
    header: t("reports.oda.upsell-cta-header"),
    "learn-more-button-url": "https://help.mixpanel.com/hc/en-us/articles/360031788492-Find-Interesting-Segments",
    open: true
  }, on: {
    change: this.helpers.handleChangeUpsellModal
  } }) : null);
}
